// Icon-Component-Cache. Tree-shakeable named imports der 16 Defaults (sub-30kB)
// plus Lazy-Resolver fuer den Long-Tail (~900 kB). Ohne diesen Cache wuerde ein
// `import * as` aus lucide-react das gesamte Icon-Set ins Initial-Bundle ziehen.

import {
  AlertTriangle,
  Building,
  CheckCircle,
  Cloud,
  Database,
  Flag,
  GitBranch,
  Globe,
  Lightbulb,
  Lock,
  Server,
  Star,
  User,
  UserCheck,
  Users,
  XCircle,
} from "lucide-react";
import type { ComponentType } from "react";

export interface LucideIconProps {
  size?: number;
  color?: string;
  absoluteStrokeWidth?: boolean;
}

export type LucideComp = ComponentType<LucideIconProps>;

const cache = new Map<string, LucideComp>([
  ["AlertTriangle", AlertTriangle as LucideComp],
  ["Building", Building as LucideComp],
  ["CheckCircle", CheckCircle as LucideComp],
  ["Cloud", Cloud as LucideComp],
  ["Database", Database as LucideComp],
  ["Flag", Flag as LucideComp],
  ["GitBranch", GitBranch as LucideComp],
  ["Globe", Globe as LucideComp],
  ["Lightbulb", Lightbulb as LucideComp],
  ["Lock", Lock as LucideComp],
  ["Server", Server as LucideComp],
  ["Star", Star as LucideComp],
  ["User", User as LucideComp],
  ["UserCheck", UserCheck as LucideComp],
  ["Users", Users as LucideComp],
  ["XCircle", XCircle as LucideComp],
]);

export function getIcon(name: string): LucideComp | undefined {
  return cache.get(name);
}

export async function ensureIcon(name: string): Promise<LucideComp | undefined> {
  const existing = cache.get(name);
  if (existing) return existing;
  const mod = await import("lucide-react");
  const lookup = mod as unknown as Record<string, unknown>;
  const cmp = lookup[name];
  if (typeof cmp === "function" || (typeof cmp === "object" && cmp !== null)) {
    const typed = cmp as LucideComp;
    cache.set(name, typed);
    return typed;
  }
  return undefined;
}

let longTailNames: readonly string[] | null = null;

export async function getAllLucideNames(): Promise<readonly string[]> {
  if (longTailNames) return longTailNames;
  const mod = await import("lucide-react");
  const lookup = mod as unknown as Record<string, unknown>;
  longTailNames = Object.keys(lookup).filter((k) => {
    if (!/^[A-Z]/.test(k)) return false;
    if (k === "default") return false;
    const t = typeof lookup[k];
    return t === "object" || t === "function";
  });
  return longTailNames;
}
